import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { Switch } from '@/components/ui/switch'
import { isLayoutQuestionType } from '@/types/form'
import type { Question } from '@/types/form'

interface CommonSettingsProps {
  question: Question
  onQuestionChange: (patch: Partial<Question>) => void
  onSettingsChange: (patch: Partial<Question['settings']>) => void
  showButtonTextSetting?: boolean
}

export function CommonSettings({
  question,
  onQuestionChange,
  onSettingsChange,
  showButtonTextSetting = false,
}: CommonSettingsProps) {
  const isLayoutBlock = isLayoutQuestionType(question.type)

  return (
    <div className="flex flex-col gap-4">
      {isLayoutBlock ? (
        <div className="rounded-md border border-slate-200 bg-slate-50 p-3 text-sm text-slate-600">
          這是版面區塊，不需要填答；它會出現在填答流程中，用來分段或說明。
        </div>
      ) : (
        <div className="flex items-center justify-between gap-3 text-sm">
          <span>此題必填</span>
          <Switch
            aria-label="此題必填"
            checked={question.required}
            onCheckedChange={(required) => onQuestionChange({ required })}
          />
        </div>
      )}
      {showButtonTextSetting ? (
        <div className="flex flex-col gap-2">
          <Label>自訂按鈕文字</Label>
          <Input
            value={question.settings.buttonText ?? ''}
            placeholder="繼續"
            onChange={(event) => onSettingsChange({ buttonText: event.target.value })}
          />
          <p className="text-xs leading-5 text-slate-500">
            只有「分題式」填寫模式會使用此按鈕文字；一頁式會使用送出問卷按鈕。
          </p>
        </div>
      ) : null}
      {!isLayoutBlock && (
        <div className="flex flex-col gap-2">
          <Label>自訂錯誤提示</Label>
          <Input
            value={question.settings.errorMessage ?? ''}
            placeholder="請完成此題"
            onChange={(event) => onSettingsChange({ errorMessage: event.target.value })}
          />
        </div>
      )}
      <div className="flex items-center justify-between gap-3 text-sm">
        <span>顯示問題編號</span>
        <Switch
          aria-label="顯示問題編號"
          checked={question.settings.showQuestionNumber !== false}
          onCheckedChange={(showQuestionNumber) => onSettingsChange({ showQuestionNumber })}
        />
      </div>
    </div>
  )
}
